import { EntityType, convertLanguage } from '@frontend/common';
import { CommonMessage } from '@frontend/lang';
import { useAccountRepository } from '@frontend/repository';
import { UserClient } from '@frontend/user/api';
import { updateCurrent } from '@frontend/user/redux';
import { IUser, UpdateUser } from '@frontend/user/types';
import { FormattedMessage } from 'react-intl';

import { DefaultContainer } from '../../../modal/detail-modal/default-container/default-container';
import { PlatformDetailGrid } from '../../../modal/platform-detail-grid/platform-detail-grid.component';
import UpdateModal from '../../../modal/update-modal/update-modal.component';
import { useAppDispatch } from '../../../redux/store';
import { useUserDetailsCard } from './user-details-card.controller';

export interface UserDetailsCardProps {
    user: IUser;
}

export const UserDetailsCard = (props: UserDetailsCardProps) => {
    const viewProps = useUserDetailsCard(props);
    const { currentAccount } = useAccountRepository();
    const dispatch = useAppDispatch();

    return (
        <DefaultContainer
            title={
                <FormattedMessage
                    id='profile.details.title'
                    defaultMessage='Details'
                    description='Title for user details card'
                />
            }
            content={
                <PlatformDetailGrid<IUser>
                    object={props.user}
                    cols={3}
                    order={['unique_identifier', 'first_name', 'last_name', 'email', 'mobile', 'language']}
                    keyOverwrite={new Map([['unique_identifier', CommonMessage.FORMS.UNIQUE_IDENTIFIER]])}
                    valueOverwrite={new Map([['language', (obj) => convertLanguage(obj.language)]])}
                />
            }
            update={{
                onUpdate: () =>
                    viewProps.openModal(viewProps.updateModalId, () => (
                        <UpdateModal<IUser, UpdateUser>
                            object={props.user}
                            values={{ ...props.user }}
                            order={['unique_identifier', 'first_name', 'last_name', 'email', 'mobile', 'language']}
                            onSubmit={(value) => UserClient.patchUser(currentAccount, props.user.id, value)}
                            type={EntityType.USER}
                            label={
                                <FormattedMessage
                                    id='profile.details.update-title'
                                    defaultMessage='Update details'
                                    description='Title for update details modal'
                                />
                            }
                            onSubmitSuccess={(updatedUser) => {
                                dispatch(updateCurrent(updatedUser));
                            }}
                        />
                    ))
            }}
        />
    );
};
